const TOLERANCIA = 1e-9;

function estoque(item) {
    const valor = Number(item && item.depiQtdDisponivel);
    return Number.isFinite(valor) ? Math.max(0, valor) : 0;
}

export function quantidadeMaximaDeposito(original, opcoes, opcao) {
    const outrasQuantidades = opcoes.reduce((total, item) =>
        total + (item === opcao ? 0 : Math.max(0, Number(item.quantidadeSelecionada) || 0)), 0);
    return Math.max(0, Math.min(estoque(opcao), estoque(original) - outrasQuantidades));
}

export function ajustarQuantidadeDeposito(original, opcoes, opcao, usarMultiplo) {
    const quantidade = Number(opcao.quantidadeSelecionada);
    if (opcao.quantidadeSelecionada == null || opcao.quantidadeSelecionada === '') return false;
    const maximo = quantidadeMaximaDeposito(original, opcoes, opcao);
    const multiplo = usarMultiplo && Number(opcao.itemEmbMult) > 0 ? Number(opcao.itemEmbMult) : null;
    let ajustada = Number.isFinite(quantidade) ? Math.max(0, Math.min(quantidade, maximo)) : 0;
    if (multiplo) ajustada = Math.floor((ajustada + TOLERANCIA) / multiplo) * multiplo;
    ajustada = Number(ajustada.toFixed(9));
    if (Number.isFinite(quantidade) && Math.abs(ajustada - quantidade) <= TOLERANCIA) return false;
    opcao.quantidadeSelecionada = ajustada;
    return true;
}

export function quantidadesDepositosValidas(original, opcoes) {
    let total = 0;
    return opcoes.every(opcao => {
        const quantidade = Number(opcao.quantidadeSelecionada);
        if (!Number.isFinite(quantidade) || quantidade < 0 || quantidade > estoque(opcao) + TOLERANCIA) return false;
        total += quantidade;
        return total <= estoque(original) + TOLERANCIA;
    });
}



// WEBPACK FOOTER //
// ./src/components/helpers/LimiteQuantidadeDepositosHelper.js